import { Link } from "react-router-dom";

// Detect brand from hostname or pathname. reklamation.gardinfabrikken.com → gardinfabrikken.
// Also supports path-based routing: reklamation.gardinbussen.org/gf → gardinfabrikken.
// Fallback: reads ?brand= query param so we can test the GF form on the current preview URL.
function detectBrand() {
    if (typeof window === "undefined") return "gardinbussen";
    const host = (window.location.hostname || "").toLowerCase();
    if (host.includes("gardinfabrikken")) return "gardinfabrikken";
    const path = (window.location.pathname || "").toLowerCase();
    if (path === "/gf" || path.startsWith("/gf/")) return "gardinfabrikken";
    const params = new URLSearchParams(window.location.search);
    if ((params.get("brand") || "").toLowerCase() === "gardinfabrikken") return "gardinfabrikken";
    return "gardinbussen";
}

const BRAND_META = {
    gardinbussen: { name: "Gardinbussen.org", logo: "/logo.png" },
    gardinfabrikken: { name: "Gardinfabrikken", logo: "/logo-gardinfabrikken.png" },
};

/**
 * Brand logo (auto-detects Gardinbussen vs Gardinfabrikken based on hostname).
 */
export default function Logo({
    size = "md",
    to,
    className = "",
}) {
    const heights = {
        sm: "h-8",
        md: "h-10",
        lg: "h-14",
    };
    const h = heights[size] || heights.md;
    const brand = detectBrand();
    const meta = BRAND_META[brand] || BRAND_META.gardinbussen;
    // Default home path stays within the brand (so clicking the logo on /gf/reklamation → /gf, not /)
    const homePath = to === undefined ? (brand === "gardinfabrikken" ? "/gf" : "/") : to;

    const img = (
        <img
            src={meta.logo}
            alt={meta.name}
            className={`${h} w-auto object-contain ${className}`}
            data-testid="brand-logo"
            data-brand={brand}
        />
    );

    if (homePath) {
        return <Link to={homePath} className="inline-block">{img}</Link>;
    }
    return img;
}

export { detectBrand, BRAND_META };
